import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "../../style.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../../Store/PageredirectSlice";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import { Commonfun, datezonechange, timezonechange, timezoneval } from '../../Commonfun';
import { AppContext } from "../../../../Context/Context";
import { Utils } from "../../../../Utils/Utils";
import Freeaudit from "../../../../Utils/Freeaudit";
import Loader from "../../CommonLoader";
import CommonAlert from "../../../../Commonalert/commonalert";
import DatagridComp from "../../DatagridComp";
// import PdfandCsv from "../PdfandCsv";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Tooltip } from '@mui/material';
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import UserActivityTracker from "../../../../hooks/userActivityTracker";

export default function ContainerSecureAudit() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobidData, setjobidData] = useState("");
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [notifycount, setNotifycount] = useState("");
  const [topActionItemPlan, settopActionItemPlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [isRefUrlPopup, setIsRefUrlPopup] = useState(false);
  const [refUrl, setRefUrl] = useState([]);

  //filter
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedJobDate, setSelectedJobDate] = useState(null);
  const [prevSelectedJobDate, setPrevSelectedJobDate] = useState(null);
  const [jobDateOptions, setJobDateOptions] = useState([]);
  //run report
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [successApiopen, setSuccessApiOpen] = useState(false);
  const [successApierrorMsg, setSucessApierrorMsg] = useState('');


  let detailurl = `${process.env.REACT_APP_DOMAIN}container-security-audit/`;

  const navigate = useNavigate()
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const dispatch = useDispatch();

  const pageRedirectfun = (e) => {
    if (e.currentTarget.id == 1)
      countdecreaseUrl("Broken Links")
    else
      countdecreaseUrl("Server Error")
    localStorage.setItem("eso_redirect_value", e.currentTarget.id);
    dispatch(SetredirectValue(e.currentTarget.id));
    navigate('/internal-link-checker')
  }
  const countdecreaseUrl = async (urldecval) => {
    const notifydecdatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}top_action_items/reduce_notification/?user_domain_id=${esodata.domaindata.value.header_selected}&to_redirect=${urldecval}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    notificationapi();

  }

  const checkUserPlan = async () => {
    const topActionItemP = await Utils("top_action_items", ApiToken);
    if (topActionItemP.status) {
      callUserdataApi();
      faqdatafun();
      notificationapi();
    }
    settopActionItemPlan(topActionItemP);
  };

  useEffect(() => {
    checkUserPlan();
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const jobDOptions = await axios
        .get(
          `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=security_audit&audit_type=container_audit`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (jobDOptions?.data) {
        if (jobDOptions.data.jobs) {
          var Sections = [];
          jobDOptions.data.jobs.forEach((element) => {
            Sections.push({ label: datezonechange(element.completed_at), value: element.id });
          });
          setJobDateOptions(Sections);
        }
      }
    } catch (err) { }
  };

  const columns = [
    {
      field: "PkgName",
      headerName: "Pkg Name",
      description: 'The name of the vulnerable package.',
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "version",
      headerName: "Version",
      description: "The version of the package found in the image.",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true
    },
    {
      field: "title",
      headerName: "Title",
      description: "A brief summary of the vulnerability.",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "description",
      headerName: "Description",
      description: 'A more detailed explanation of the vulnerability.',
      minWidth: 300,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      description: ' The severity level of the vulnerability',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "PrimaryURL",
      headerName: "References",
      description: 'Links to external resources providing more information about the vulnerability.',
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.PrimaryURL.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.PrimaryURL.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.PrimaryURL}>
              <div className="prefered_url_external02">
                <a
                  target="_blank"
                  href={cardData?.row?.PrimaryURL}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );
      },
    },

    //  {
    //   field: "References",
    //   headerName: "References URL",
    //   description: 'The number of occurrences of the issue. A higher impact means the problem is more widespread.',
    //   minWidth: 150,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    // },

    {
      field: "References",
      headerName: "View",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      description: 'Click to view the detailed report',
      align: 'center',
      sortable: false,
      renderCell: (cardData) => {
        return (
          // <a href={detailurl + `${cardData.row.id}` + "/" + `${jobidData}`}>
          <button className="view-report-button" onClick={() => { setRefUrl(cardData.row.References); setIsRefUrlPopup(true); }}>
            View Report
          </button>
          // </a>
        );
      },
    },

  ];

  const rows = cardData ?? [];
  const notificationapi = async () => {
    const notifydatavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}top_action_items/top_action_notification/?user_domain_id=${esodata.domaindata.value.header_selected}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    setNotifycount(notifydatavalue?.data?.notification_count)
  }
  const callUserdataApi = async (jobId = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/container_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        if (error?.response?.data?.security_config) {
          const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
          setapierrorMsg(securityError);
        } else {
          setapierrorMsg(error?.response?.data?.error)
        }
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    if (datavalue?.data?.table_data) {
      const dataval = datavalue?.data?.table_data;
      console.log("data", dataval);
      setjobDate(datavalue?.data?.job_date);
      SetAutoheightval(false)

      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);

    }
    else {
      SetAutoheightval(true)
      setCardData("No report available");
    }

    setTableLoading(false);
    setLoading(false);
  };
  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/container_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("container security audit", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/container_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&timezone=${timezoneval()}&job_id=${jobId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'container security audit.csv';

        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=71`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setDownload(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleModelPopUp = () => {
    openModal();
  }

  function openModal() {
    setIsFilterOpen(true);
  }

  function closeModal() {
    setIsFilterOpen(false);
    setSelectedJobDate(prevSelectedJobDate);
  }

  const filterNow = () => {
    const jobId = selectedJobDate ? selectedJobDate : { label: '', value: '' };
    callUserdataApi(jobId.value);
    setPrevSelectedJobDate(jobId);
    setIsFilterOpen(false);
  }

  const handleReset = () => {
    setSelectedJobDate(null);
  }

  //Run report

  const closeRunReport = () => {
    setIsReportOpen(false);
  }

  const runReportNow = async () => {
    setLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}security_tools/run_security_report/?user_domain_id=${esodata.domaindata.value.header_selected}&report_type=container_audit`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    if (datavalue?.status === 200) {
      setSuccessApiOpen(true);
      setSucessApierrorMsg(datavalue?.data?.success);
    }

    setIsReportOpen(false);
    setLoading(false);
  };

  const successApiClose = () => {
    setSuccessApiOpen(false);
  }

  const closeTracePopup = () => {
    setIsRefUrlPopup(false);
  }


  return (
    <div className={`over_all_container top_action_list ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Docker Container Audit</title>
      </Helmet>

      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Docker Container Audit
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Docker Container Audit', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">

                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <button
                  title="Security Audit Settings"
                  className="btn_dashboard"
                  onClick={() => navigate('/security-audit-settings')}
                >
                  Security Audit Settings
                </button>
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => setIsReportOpen(true)}
                // onClick={() => {
                //   if (first.statusDomain) {
                //     setcheckD(first.statusDomain);
                //   } else {

                //     setfaqData(2);
                //     setToggle(false);
                //     SetRunReportPopShow(true);
                //   }
                // }}
                // disabled={!analysisSummaryPlan.status}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {topActionItemPlan.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[2]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={true}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                  : <Freeaudit planStatus={topActionItemPlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        <div >
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      </div>


      <Dialog
        open={isFilterOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Filter By"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div >
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={selectedJobDate}
                      options={jobDateOptions}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectedJobDate(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={filterNow}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeModal}>
            close
          </button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isReportOpen}
        onClose={closeRunReport}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Run Report"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div>
              Can we run the report for Container Audit ?
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={runReportNow}
            style={{ cursor: "pointer" }}
          >
            Run
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isRefUrlPopup}
        onClose={closeTracePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Reference URLs"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {refUrl.map(referenceUrl => {
                let baseUrl =
                  referenceUrl.split("/").slice(0, 3).join("/") + "/";
                let remaining = referenceUrl.split("/").slice(3).join("/");
                return (
                  <>
                    {/* <Tooltip title={referenceUrl}> */}
                    <div className="prefered_url_external02" style={{ marginBottom: '5px' }}>
                      <a
                        target="_blank"
                        href={referenceUrl}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <span className="spanlink">
                          <LinkIcon /> {baseUrl}
                        </span>
                        <span
                          className="spanlink"
                          style={{
                            color: "#044792",
                            wordWrap: "break-word",
                            wordBreak: "break-word",
                          }}
                        >
                          {remaining}
                        </span>
                      </a>
                    </div>
                    {/* </Tooltip> */}
                  </>
                );
              })}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button style={{ cursor: "pointer" }} onClick={closeTracePopup}>
            Close
          </button>
        </DialogActions>
      </Dialog>

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />

      <CommonErrorAlert
        data={{
          apiopen: successApiopen,
          apiErrorMsg: successApierrorMsg,
          isIconStyled: false
        }}
        closeAlert={successApiClose} />
      <UserActivityTracker pagename="Security Tools - Docker Container Audit" />

    </div>
  );
}
